<template>
  <PBannerBase type="warning">
    <template #title>
      <span style="font-size: 12px; font-weight: 400">
        Veja o histórico e resultados de tentativas de comunicação entre o F360
        Finanças e seus sistemas conectados ( adquirentes ,PDVs, Nfe e Open
        Finance)
      </span>
    </template>
  </PBannerBase>
</template>

<script setup lang="ts">
import { PBannerBase } from "@f360-dev/f360-prisma";
</script>

<style scoped></style>
